<template>
  <div class="post">
    <Error v-if="error" :error="error"/>
    <Loading v-if="loading"/>

    <PostView v-if="post"
      :avatar="post.avatar"
      :name="post.name"
      :pid="post.id"
      :likes="likes"
      :title="$pick(post.titles)"
      :text="$pick(post.contents)"
      :attachments="post.attachments"/>
    <PostReply v-for="reply in replies" :key="reply.id"
      :avatar="reply.avatar"
      :name="reply.name"
      :text="$pick(reply.contents)"/>
  </div>
</template>

<script>
import Error from '../Error';
import Loading from '../Loading';

import PostView from './Post/PostView';
import PostReply from './Post/PostReply';

export default {
  name: 'Post',
  data() {
    return {
      error: null,
      loading: null,

      post: null,
      replies: null,
      likes: 0,
    };
  },
  components: {
    Error,
    Loading,

    PostView,
    PostReply,
  },
  created () {
    this.fetchData()
  },
  mounted () {
    const s = this.$el && this.$el.closest ? this.$el.closest('.im') : null;
    if (s) s.scrollTop = 0;
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.error = this.post = this.replies = null;
      this.loading = true;
      fetch(`./data/imposts/${this.$route.params.id}.json`).then(res => {
        this.loading = false;
        if (res.ok) res.json().then(data=>{
          this.post = data;
          this.replies = data.replies;
        }); else {
          this.error = res.status+' '+res.statusText
        }
      });
      // the like count of the post is in the list, not in the post file
      fetch('./data/imlist.json').then(res => res.ok ? res.json() : []).then(list => {
        const me = (list || []).find(i => i.id === this.$route.params.id);
        this.likes = me ? me.likes : 0;
      }).catch(() => {});
    }
  }
}
</script>
